export const myPath = {
    loading: "loading",
    home: "home",
    setting: "setting",
    signEnter: "sign-enter",

    localAddInfo: "localAddInfo",

    visitCodeCome: "code-enter",
    visitCodeLeave: "code-leave",


    registerSelect: "regist-select",
    localRegister: "local-regest",
    idCardRegister: "idcard-regest",

    enterSelect: "enter-select",
    qrcodeCome: "qrcode-enter",
    idCardCome: "idcard-enter",
    phoneCome: "phone-enter",

    leaveSelect: "leave-select",
    qrcodeLeave: "qrcode-leave",
    idCardLeave: "idcard-leave",
    phoneLeave: "phone-leave",

    printPage: "printPage",


}

export const errMsg = {
    SERVER_ERR: "服务器异常,请联系IT运营人员,错误码-",
    NETWORK_ERR: "网络发生故障，请稍后再试，并请联系网络管理人员",
}

export const mCfg = {
    DEVICE_TYPE_MACHINE: "VISIT_MACHINE",
    DEVICE_TYPE_PAD: "PAD",
    LOG_SWITCH: true,
    DEVICE_TYPE: "VISIT_MACHINE",
}

export default {
    install(vue) {
        console.log("constant install")


        vue.prototype.myPath = myPath
        vue.prototype.mCfg = mCfg

        vue.mixin({
            methods: {
                showNetErrMsg() {
                    // this.$message.error(errMsg.NETWORK_ERR)
                },
                showServerErrMsg(errCode) {
                    this.$message.error(errMsg.SERVER_ERR + errCode)
                },
                logD(...data) {
                    if (mCfg.LOG_SWITCH) {
                        console.log(data)
                    }
                },
                logI(...data) {
                    console.info(data)
                },
                logE(...data) {
                    console.error(data)
                },
            }
        })
    }
}

